import React from 'react';
import PropTypes from 'prop-types';

// COMPONENTS
import { SwiperSlide } from '@/components/Carousels/SwiperCarousel';
import StageCarousel from '@/components/Carousels/StageSwiperCarousel';
import BannerPromo from '@/components/Banners/BannerPromo';

// STYLES
import { Container } from './styles';

const carouselOptions = {
  loop: true,
  spaceBetween: 15,
  pagination: true,
  // autoplay: {
  //   delay: 2500,
  // },
};

const MultipleBanners = ({ data, analyticsProps, analyticsLocation }) => {
  return (
    <Container className="multiple-banners">
      <StageCarousel carouselOptions={carouselOptions}>
        {data.map((bannerData, card_index) => (
          <SwiperSlide key={card_index}>
            <BannerPromo
              analyticsProps={{
                ...analyticsProps,
                link: bannerData.link,
              }}
              data={bannerData}
              link={bannerData.link || ''}
              analyticsLocation={analyticsLocation}
            />
          </SwiperSlide>
        ))}
      </StageCarousel>
    </Container>
  );
};

MultipleBanners.defaultProps = {
  analyticsProps: {},
};

MultipleBanners.propTypes = {
  data: PropTypes.array.isRequired,
  analyticsLocation: PropTypes.string.isRequired,
  analyticsProps: PropTypes.object,
};

export default React.memo(MultipleBanners);
